import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { NotFoundPage } from "../Errors/NotFound";
import { DebugPage } from "./Page";
import { PullToRefreshDebugPage } from "./Pages/PullToRefresh/Page";
import { ScreenBrightnessDebugPage } from "./Pages/ScreenBrightnessDebugPage";

export function DebugRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.path}>
        <DebugPage />
      </Route>
      <Route exact path={`${match.path}/pull-to-refresh`}>
        <PullToRefreshDebugPage />
      </Route>
      <Route exact path={`${match.path}/screen-brightness`}>
        <ScreenBrightnessDebugPage />
      </Route>
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  );
}
